/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { QAAnalyticsResults } from './QAAnalyticsResults';
import {
    QAAnalyticsResultsFromJSON,
    QAAnalyticsResultsFromJSONTyped,
    QAAnalyticsResultsToJSON,
} from './QAAnalyticsResults';

/**
 * Extends outputs for "list" type operations to return pagination details
 * @export
 * @interface GetCallibrationDataWithFiltersResponseContent
 */
export interface GetCallibrationDataWithFiltersResponseContent {
    /**
     * Pass this in the next request for another page of results
     * @type {string}
     * @memberof GetCallibrationDataWithFiltersResponseContent
     */
    nextToken?: string;
    /**
     * 
     * @type {QAAnalyticsResults}
     * @memberof GetCallibrationDataWithFiltersResponseContent
     */
    analytics: QAAnalyticsResults;
    /**
     * Total number of pages
     * @type {number}
     * @memberof GetCallibrationDataWithFiltersResponseContent
     */
    totalPages?: number;
    /**
     * Total number of records
     * @type {number}
     * @memberof GetCallibrationDataWithFiltersResponseContent
     */
    totalRecords?: number;
}


/**
 * Check if a given object implements the GetCallibrationDataWithFiltersResponseContent interface.
 */
export function instanceOfGetCallibrationDataWithFiltersResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "analytics" in value;

    return isInstance;
}

export function GetCallibrationDataWithFiltersResponseContentFromJSON(json: any): GetCallibrationDataWithFiltersResponseContent {
    return GetCallibrationDataWithFiltersResponseContentFromJSONTyped(json, false);
}

export function GetCallibrationDataWithFiltersResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCallibrationDataWithFiltersResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextToken': !exists(json, 'nextToken') ? undefined : json['nextToken'],
        'analytics': QAAnalyticsResultsFromJSON(json['analytics']),
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
        'totalRecords': !exists(json, 'totalRecords') ? undefined : json['totalRecords'],
    };
}

export function GetCallibrationDataWithFiltersResponseContentToJSON(value?: GetCallibrationDataWithFiltersResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextToken': value.nextToken,
        'analytics': QAAnalyticsResultsToJSON(value.analytics),
        'totalPages': value.totalPages,
        'totalRecords': value.totalRecords,
    };
}

